export default __webpack_public_path__ + "static/media/ca-ontario-hwy.2af94588.svg";